import * as yup from "yup";


const logoSchema = yup.array().of(
    yup.object().shape({
      file: yup
        .mixed()
        .required("Image is required")
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) {
            return true;
          }
          const file = value.file;
          const fileExtension = file.name.split(".").pop().toLowerCase();
          const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
          return supportedFormats.includes(fileExtension);
        }),
      link: yup.string().url(""),
      target: yup.string(),
      order: yup.string().required(""),
      alt: yup.string().required(""),
    })
  );
  const logoSchemaForPartners = yup.array().of(
    yup.object().shape({
      file: yup
        .mixed()
        .required("Image is required")
        .test("fileFormat", "Unsupported file format", (value) => {
          if (!value || !value.file) {
            return true;
          }
          const file = value.file;
          const fileExtension = file.name.split(".").pop().toLowerCase();
          const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
          return supportedFormats.includes(fileExtension);
        }),
      order: yup.string().required(""),
    })
  );
  
  const schemas = yup.object().shape({
    main_right_banner_desktop: logoSchema,
    // campaignId: yup.string().required("Campaign ID is required"),
    uiType: yup.string().required("UI Type is required"),
    rechange_heading: yup.string().required("rechange_heading is required"),
    rechange_subHeading: yup.string().required("rechange_subHeading is required"),
    exclusive_heading: yup.string().required("exclusive_heading is required"),
    exclusive_subHeading: yup
      .string()
      .required("exclusive_subHeading is required"),
    prime_heading: yup.string().required("prime_heading is required"),
    prime_subHeading: yup.string().required("prime_subHeading is required"),
    coins_heading: yup.string().required("coins_heading is required"),
    coins_subHeading: yup.string().required("coins_subHeading is required"),
    partners_heading: yup.string().required("partners_heading is required"),
    partners_subHeading: yup.string().required("partners_subHeading is required"),
    disclaimer: yup.string().required("disclaimer is required"),
    main_right_banner_mobile: logoSchema,
    recharge_left_banner_desktop: logoSchema,
    recharge_left_banner_mobile: logoSchema,
    recharge_right_banner_desktop: logoSchema,
    recharge_right_banner_mobile: logoSchema,
    exclusive_banner_desktop: logoSchema,
    exclusive_banner_mobile: logoSchema,
    prime_left_banner_desktop: logoSchema,
    prime_left_banner_mobile: logoSchema,
    prime_right_banner_desktop: logoSchema,
    coins_banner_desktop: logoSchema,
    coins_banner_mobile: logoSchema,
    vouchers_mobile: logoSchema,
    vouchers_desktop: logoSchema,
    partners: logoSchemaForPartners,
  });


export default schemas